import { GTAG, HUBSPOT, JUNE_SO } from "@stadium/services/analytics/constants/services";

export const ACCOUNT_DROPDOWN = "account-dropdown";
export const STADIUM_NAVBAR = "stadium-navbar";
export const FEATURE_PACKAGES = "feature-packages";
export const FEATURE_PACKAGES_MODAL = "modal";

export const PURCHASE_PACKAGE = "name-purchase-package";
export const SPEAK_WITH_EXPERT = "speak-with-an-expert";
export const PACKAGE_INFO_ICON = "i-icon-name";
export const FEATURE_PACKAGE_BUTTON = "package-button";
export const VIEW_FEATURE_PACKAGE = "view-feature-packages";
export const TALK_TO_SALES = "talk-to-sales";
export const GET_STARTED_FOR_FREE = "get-started-for-free";
export const CHARGEBEE_MODAL = "chargebee-modal";
export const ALREADY_SUBSCRIBED_MODAL = "already-subscribed-modal";
export const BOOK_A_CALL = "book-a-call";
export const LOGIN_CTA = "login-cta";
export const PURCHASE_CTA = "purchase-cta";
export const NAVBAR = "navbar";
export const CHARGEBEE_FLOW = "chargebee";
export const CHECKOUT = "checkout";

//actions
export const PAYMENT_SUCCESS = "payment-success";
export const PAYMENT_ERROR = "payment-error";

export const LOGGED_OUT_STADIUM_NAVBAR = "logged-out-stadium-navbar";

export const DEFAULT_SERVICES = Object.freeze([JUNE_SO]);

export const ACCOUNT_DROPDOWN_CTA_SERVICES = DEFAULT_SERVICES;
export const HEADER_LINKS_SERVICES = DEFAULT_SERVICES;
export const FEATURE_PACKAGES_SERVICES = [...DEFAULT_SERVICES, GTAG, HUBSPOT];
export const CHARGEBEE_SERVICES = [...DEFAULT_SERVICES, GTAG, HUBSPOT];
export const BOOK_A_CALL_SERVICES = [...DEFAULT_SERVICES, GTAG, HUBSPOT];
export const LOGIN_CTA_SERVICES = [...DEFAULT_SERVICES, GTAG, HUBSPOT];
